export const showMediaPdfWindow = (mediaFileUrl: string): void => {
  const mediaWindow = window.open('', '', `fullscreen=1,scrollbars=1,resizable=1`)
  const html = windowTemplate.replace('{{url}}', mediaFileUrl).replace('{{title}}', 'Pdf')

  if (mediaWindow) {
    mediaWindow.document.title = 'Pdf'
    mediaWindow.document.open()
    mediaWindow.document.write(html)
    mediaWindow.document.location.href = '#'
    mediaWindow.document.close()
  }
}

const windowTemplate = `
<html lang="en" style="height:100%;">
    <head>
        <meta charset="utf-8">
        <title>{{title}}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <style>
        body {
            padding:0;
            margin:0;
            height:100%;
        }
        </style>
    </head>
    <body>
        <object id="pdf-viewer" data="{{url}}" type="application/pdf" style="width:100%;height:100%;"></object>
    </body>
</html>`
